import {Ref} from "vue";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import SearchingAndSuggestionUtil from "@/utils/editView/widgets/SearchingAndSuggestionUtil.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import FieldMetaData = namaTypes.FieldMetaData;
import EntityReferenceData = namaTypes.EntityReferenceData;
import FieldActionContextInfo = namaTypes.FieldActionContextInfo;

export default class ExtraCodeFieldWidgetUtil extends FieldWidgetUtil
{
  constructor(presenter: WidgetsPresenter, fieldMetaData: FieldMetaData) {
    super(presenter, fieldMetaData);
  }

  override onUserInputFinished = async () => {
    let inputFieldValue = this.inputFieldValueRef.value;
    this.onPartialUserInput(inputFieldValue);
    let originalValue = this.fetchFieldValue();
    let parsedValue = this.formatterInstance.parse(this.fieldMetaData.fieldSpecs, inputFieldValue, originalValue);
    if (this.presenter.isEditPresenter() && originalValue !== parsedValue) {
      let searchContextInfo: FieldActionContextInfo = this.presenter.createSearchContextInfo(this.fieldId())
      let matchedRecord = await SearchingAndSuggestionUtil.findByBusinessCode(this.presenter.entityType, inputFieldValue
        , searchContextInfo);
      const currentRecord = this.presenter.fetchRecord();
      const isSameRecord = matchedRecord && matchedRecord.id === currentRecord.id && matchedRecord.entityType === currentRecord.entityType;
      if (matchedRecord && !isSameRecord) {
        await (this.presenter as EditPresenter).updateRecordWhenCodeChanged(this.fieldId(), matchedRecord);
        return;
      }
    }
    await this.updateValueAndCallPostAction(parsedValue, originalValue);
  }

  async suggest(val: string | null | undefined, options: Ref<EntityReferenceData[]>) {
    let contextInfo: FieldActionContextInfo = this.presenter.createSearchContextInfo(this.fieldId());
    let ownerEntityType = this.presenter.entityType;
    options.value = await SearchingAndSuggestionUtil.searchFor({
      query: val || "",
      ownerEntityType,
      contextInfo,
      referencedEntityType: ownerEntityType,
      fieldId: this.fieldId(),
      extraCriteriaId: this.presenter.fetchExtraCriteriaIdFromPlace(),
      extraCriteria: this.presenter.fetchCriteriaFromFilterField(ownerEntityType, this.fieldId())
      }
    ) ?? [];
  }

  onSelectFromSuggestionList = async (value?: EntityReferenceData) => {
    let originalValue = NamaCommon.getFieldValue(this.presenter.fetchRecord(), CommonFieldIds.ID);
    if (value && value.id !== originalValue && this.presenter.isEditPresenter()) {
      await this.presenter.goToEntityFromField(this.fieldId(), value);
    }
  }
}
